export default __webpack_public_path__ + "static/media/cerebro-alongando.c8d171c9.gif";